(()=>{'use strict';
const $=(s,r=document)=>r.querySelector(s),$$=(s,r=document)=>[...r.querySelectorAll(s)];
const money=v=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(v/100);
const safe=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
$$('[data-image]').forEach(button=>button.addEventListener('click',()=>{const img=$('#gallery-main');img.src=button.dataset.image;img.alt=button.getAttribute('aria-label');$$('[data-image]').forEach(b=>{b.classList.toggle('active',b===button);b.setAttribute('aria-pressed',String(b===button));});}));
const vd=$('.video-dialog'),video=$('video',vd);let videoTrigger;
$$('[data-video]').forEach(b=>b.addEventListener('click',()=>{videoTrigger=b;video.src=b.dataset.video;vd.showModal();video.play().catch(()=>{});}));
const closeVideo=()=>vd.close();$('[data-close-video]').addEventListener('click',closeVideo);vd.addEventListener('click',e=>{if(e.target===vd)closeVideo();});vd.addEventListener('close',()=>{video.pause();video.removeAttribute('src');video.load();videoTrigger?.focus();});
const sticky=$('.sticky-buy');new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting;},{threshold:0}).observe($('.product-form__submit'));
// Reuse the site's existing MoonBundle cart; never render a second reduced cart.
class LandingCart extends HTMLElement{
 async open(){
  if(this.opening)return this.opening;
  this.opening=(async()=>{
   const triggers=$$('[data-open-cart]');triggers.forEach(e=>e.setAttribute('aria-busy','true'));
   try{
    let native;
    for(let attempt=0;attempt<60;attempt++){
     native=$('moonbundle-cart-drawer-block');
     if(native&&typeof native.open==='function')break;
     await new Promise(resolve=>setTimeout(resolve,200));
    }
    if(native&&typeof native.open==='function'){
     if(typeof native.loadCart==='function')await native.loadCart();
     native.open();
    }else window.location.assign('/cart');
   }catch(error){console.warn('Site cart unavailable; opening cart page',error);window.location.assign('/cart');}
   finally{triggers.forEach(e=>e.removeAttribute('aria-busy'));this.opening=null;}
  })();return this.opening;
 }
}
if(!customElements.get('cart-popup'))customElements.define('cart-popup',LandingCart);
$$('[data-open-cart]').forEach(b=>b.addEventListener('click',()=>$('cart-popup').open()));
fetch('/cart.js').then(r=>r.json()).then(c=>$$('[data-cart-count]').forEach(e=>e.textContent=c.item_count)).catch(()=>{});
})();
